<template>
    <v-card variant="flat" rounded="10" class="mb-5 pa-5 border-1">
        <div class="pa-4 mt-1 bg-lightblue rounded-10">
            <div
                class="font-weight-600 font-size-18 text-darkblue line-height-24"
            >
                {{ data.name }}
            </div>

            <div class="text-blacknew font-size-14 mt-2">
                Berlaku selama {{ package_periode }}
            </div>
        </div>

        <div class="mt-5 font-weight-600 text-blacknew">Deskripsi Paket:</div>

        <div class="mt-2 line-height-24 text-blacknew font-size-14">
            {{ data.description }}
        </div>

        <hr class="my-5 dashed" />

        <div class="pb-1 bg-white">
            <div>
                <div
                    v-for="(feature, i) in features"
                    :key="i"
                    class="d-flex gap-10 mb-2"
                >
                    <div>
                        <img
                            :src="require('@/assets/icons/checklist-blue.svg')"
                        />
                    </div>

                    <div
                        class="font-size-14 text-blacknew"
                        v-html="feature"
                    ></div>
                </div>
            </div>

            <hr class="my-5 dashed" />

            <div v-if="discount_status && data.discount_exp_time">
                <div
                    class="d-flex align-center justify-space-between bg-chilired text-white rounded-9 px-3 py-2 font-weight-600 font-size-14"
                >
                    <div class="d-flex align-center gap-10">
                        <img :src="require('@/assets/icons/lightning.svg')" />
                        <div>Diskon Berakhir dalam</div>
                    </div>
                    <div>{{ countdown }}</div>
                </div>
            </div>

            <div v-if="discount_status" class="d-flex align-center gap-10 mt-4">
                <v-chip
                    rounded="5"
                    class="px-2 py-1 font-weight-600 text-chilired"
                    color="lightred"
                >
                    {{ data.discount }}%
                </v-chip>

                <div class="text-chilired font-size-18 font-weight-600">
                    Rp {{ formatNumber(data.actual_price) }}
                </div>

                <div
                    class="text-darkgrey font-size-14 font-weight-400"
                    style="text-decoration: line-through"
                >
                    Rp {{ formatNumber(data.normal_price) }}
                </div>
            </div>

            <div v-else class="d-flex align-center gap-10 mt-4">
                <div class="text-chilired font-size-18 font-weight-600">
                    Rp {{ formatNumber(data.normal_price) }}
                </div>
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            countdown: '00 : 00 : 00 : 00',
            timer: null,
        };
    },

    computed: {
        features() {
            const feature_package = this.data.feature_package || '';
            const matches = feature_package.match(/<li>(.*?)<\/li>/g);

            const data = matches
                ? matches.map((item) => item.replace(/<\/?li>/g, ''))
                : [];

            return data;
        },

        package_periode() {
            const package_type = this.data.type;
            let package_periode = null;

            if (package_type === 'ANNUALLY') {
                package_periode = '1 tahun';
            }

            if (package_type === 'NINE_MONTH') {
                package_periode = '9 Bulan';
            }

            if (package_type === 'SIX_MONTH') {
                package_periode = '6 Bulan';
            }

            if (package_type === 'THREE_MONTH') {
                package_periode = '3 Bulan';
            }

            if (package_type === 'MONTHLY') {
                package_periode = '1 Bulan';
            }

            if (package_type === 'WEEKLY') {
                package_periode = '1 Minggu';
            }

            return package_periode;
        },

        discount_status() {
            const discount = this.data.discount;
            const discount_exp_time = this.data.discount_exp_time;
            const now = this.$moment();
            let status = true;

            if (discount_exp_time) {
                if (this.$moment(discount_exp_time).isAfter(now)) {
                    status = true;
                } else {
                    status = false;
                }
            }

            if (!discount) {
                status = false;
            }

            return status;
        },
    },

    beforeUnmount() {
        clearInterval(this.timer);
    },

    mounted() {
        this.startCountdown();
    },

    methods: {
        formatNumber(val = 0) {
            return val.toLocaleString('id-ID');
        },

        startCountdown() {
            const end = this.$moment(this.data.discount_exp_time);

            this.timer = setInterval(() => {
                const now = this.$moment();
                const duration = this.$moment.duration(end.diff(now));

                if (duration.asMilliseconds() <= 0) {
                    clearInterval(this.timer);
                    this.countdown = '00 : 00 : 00 : 00';
                    return;
                }

                const days = String(duration.days()).padStart(2, '0');
                const hours = String(duration.hours()).padStart(2, '0');
                const minutes = String(duration.minutes()).padStart(2, '0');
                const seconds = String(duration.seconds()).padStart(2, '0');

                this.countdown = `${days} : ${hours} : ${minutes} : ${seconds}`;
            }, 1000);
        },
    },
};
</script>
